"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeGetIntegrationsById = exports.getIsFulfilled = exports.getIsPending = exports.getIsIdle = exports.getStatus = exports.getIntegrationsState = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _integrations = require("./integrations.reducer");

var getIntegrationsState = function getIntegrationsState(state) {
  return state.modules.users.integrations;
};

exports.getIntegrationsState = getIntegrationsState;
var getStatus = (0, _ramda.pipe)(getIntegrationsState, (0, _ramda.prop)('status'));
exports.getStatus = getStatus;
var getIsIdle = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Idle));
exports.getIsIdle = getIsIdle;
var getIsPending = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Pending));
exports.getIsPending = getIsPending;
var getIsFulfilled = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Fulfilled));
exports.getIsFulfilled = getIsFulfilled;

var selectors = _integrations.integrationsAdapter.getSelectors(getIntegrationsState);

var makeGetIntegrationsById = selectors.getById;
exports.makeGetIntegrationsById = makeGetIntegrationsById;